module.exports = __webpack_public_path__ + "static/media/Card_PD.495ccccd.svg";